import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { BoletoPrePagoComponent } from './boleto-pre-pago.component';
import { SolicitePedidoPrePagoComponent } from './solicite-pedido-pre-pago/solicite-pedido-pre-pago.component';
import { GeraPedidoPrePagoComponent } from './gera-pedido-pre-pago/gera-pedido-pre-pago.component';

const routes: Routes = [{
  path: '',
  component: BoletoPrePagoComponent,
  children: [
    {
      path: 'solicite-pedido-pre-pago',
      component: SolicitePedidoPrePagoComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['SOLICITE_SEU_PEDIDO']},
    },  
    {
      path: 'gera-pedido-pre-pago',
      component: GeraPedidoPrePagoComponent,      
    }, 
  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class BoletoPrePagoRoutingModule { }

export const routedComponents = [
  BoletoPrePagoComponent,  
  SolicitePedidoPrePagoComponent,
  GeraPedidoPrePagoComponent,
];
